/**
 * @file 游戏下拉列表 TextBubbles 浮层配置。
 * 层级对齐 `dba-new-chart-search-tag-bubble`（高于子版本面板 2004）。
 */

/** portal overlay class，供浮窗外点关闭白名单 */
export const CHART_GAME_LIST_BUBBLE_OVERLAY_CLASS = 'dba-new-chart-game-list-bubble';

/** 列表行 / 触发器 TextBubbles 共用 bubbleProps */
export const CHART_GAME_LIST_TEXT_BUBBLE_PROPS = {
  overlayClassName: `dba-nav-menu-overlay ${CHART_GAME_LIST_BUBBLE_OVERLAY_CLASS}`,
  escapeWithReference: true,
};
